import { useRecoilTransaction_UNSTABLE } from "recoil"

import { designLocalState } from "~/containers/Proposal/state/designs/design-state"

import type { TransactionOperation } from ".."
import { findPanelState, panelSelectionState } from "../../panels"
import { areasOfPanelsIndexState } from "../../relations"
import type {
  UnknownChangeForUnknownElement,
  UnknownRelationAction,
} from "../../timeline"
import { findNewRelationActionsState, findNewActionsState } from "../../timeline"
import {
  divergeTimeline,
  generateElementChange,
} from "../../timeline/transactions"

export const finishMove: TransactionOperation = (transactors) => {
  const { get, set } = transactors
  const panelIds = [...get(panelSelectionState)]
  panelIds.forEach((id) =>
    set(findPanelState(id), (current) => ({
      ...current,
      x: current.xSnap ?? current.x,
      y: current.ySnap ?? current.y,
      xSnap: null,
      ySnap: null,
    })),
  )
  const { phase } = get(designLocalState)
  const newActionsState = findNewActionsState(phase)
  const newRelationActionsState = findNewRelationActionsState(phase)
  const newActions = get(newActionsState)
  const newRelationActions = get(newRelationActionsState)
  if (newActions) {
    const changes: (UnknownChangeForUnknownElement | undefined)[] =
      newActions.map(
        (action): UnknownChangeForUnknownElement =>
          generateElementChange(transactors, { action, from: `undo` }),
      )

    if (newRelationActions) {
      const areasOfPanelsIndex = get(areasOfPanelsIndexState)

      const newRelationsChanges: (UnknownChangeForUnknownElement | undefined)[] =
        newRelationActions.map(
          (action): UnknownChangeForUnknownElement | undefined => {
            const currentAreaId = areasOfPanelsIndex.from(action.relatedId)
            if (currentAreaId === action.id) {
              return undefined
            }
            // we know now that one id must be defined, since both are not undefined
            const id = (currentAreaId ?? action.id) as string
            const undo = {
              ...action,
              id,
            } as UnknownRelationAction

            return generateElementChange(transactors, {
              action: undo,
              from: `undo`,
            })
          },
        )
      changes.push(...newRelationsChanges)
    }

    set(newActionsState, [])
    set(newRelationActionsState, [])

    divergeTimeline(transactors, changes)
  }
}
export const useFinishMove = (): VoidFunction =>
  useRecoilTransaction_UNSTABLE((transactors) => () => finishMove(transactors))
